import React, { useContext } from 'react';

import { LabelsContext, ThemeContext } from 'helpers/contexts';
import * as S from './style';
import Text from 'components/common/Text';
import * as Constant from 'constant';

/**
 * LegalDocuments component renders Terms of Service and Privacy Policy links.
 * 
 * @component
 * @param {Object} props - Component props
 * @param {string} [props.linkColor] - Link color override  
 * @param {boolean} [props.isRtl=false] - Whether text should be right-to-left
 * @param {boolean} [props.isMobile=false] - Whether to apply mobile-specific styling

 * @returns {JSX.Element} The rendered Terms of Service and Privacy Policy links component
 * 
 * @example
 * // Basic usage
 * <LegalDocuments />
 * 
 * @example
 * // With custom styling and mobile layout
 * <LegalDocuments 
 *   linkColor="#007bff"
 *   isRtl={true}
 *   isMobile={true}
 * />
 */
export function LegalDocuments({ linkColor, isRtl = false, isMobile = false }) {
  const labels = useContext(LabelsContext);
  const { colors } = useContext(ThemeContext);
  linkColor ??= colors.blue.royalBlue;
  const { signUp } = labels;
  const legalText = signUp.legalAgreement;

  return (
    <S.LegalContainer isRtl={isRtl} isMobile={isMobile}>
      <Text size={isMobile ? Constant.SIZE.small : Constant.SIZE.xxs}>
        {legalText.text}
        <S.LegalLink href={legalText.termsUrl} target="_blank" linkColor={linkColor} aria-label={`${legalText.termsText} ${legalText.opensInNewTab}`}>
          {legalText.termsText}
        </S.LegalLink>
        {legalText.and}
        <S.LegalLink
          href={legalText.privacyUrl}
          target="_blank"
          linkColor={linkColor}
          aria-label={`${legalText.privacyText} ${legalText.opensInNewTab}`}
        >
          {legalText.privacyText}
        </S.LegalLink>
      </Text>
    </S.LegalContainer>
  );
}
